import React from 'react';
import ReactFlow, { removeElements } from 'react-flow-renderer';
import Ws from '../../providers/Ws';
import Utils from '../../providers/Utils';
import { Grid } from '@material-ui/core';
import TabelTaskIdeea from '../../commons/TabelTaskIdeea';
import LocalStorage from '../../providers/LocalStorage';
import FromServer from './FromServer'
import SpecificComponent from '../../commons/SpecificComponent';
import { ReactComponent as Info } from '../../Pics/iconsManagement/Info.svg';

export default class OtherViewProiectIntegral extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            thinkViewHeight: window.innerHeight / 3,
            tableViewHeight: 76 / 2,
            ascunde: false,
            elements: [],
            taskTitle: '',
            etapaSelectata: {},
            elSelectat: {},
            taskSelectat: {},
            firstTime: true,
            showThink: false
        }
    }

    componentDidMount() {
        this.elements()
    }


    componentWillUnmount() {
        this.setState({
            elements: [],
            showThink: false
        })
    }


    ws = new Ws()
    ut = new Utils()


    elements = () => {
        let el = [];

        let screenHeight = window.innerHeight / 3

        console.log('screenHeight :>> ', screenHeight);

        let etape = [...this.props.listEtape]
        let taskuri = [...this.props.listTaskuri]
        let subTaskuri = [...this.props.listSubTaskuri]


        console.log('etape :>> ', etape);

        el.push(
            {
                id: `proiect`,
                style: { borderRadius: 20 + 'px', width: 'fit-content', maxWidth: 150 + 'px' },
                type: 'input',
                connectable: false,
                data: {
                    label: <span
                        className='word-ellipsis'
                    >{this.props.objProiectInfo[0].titlu} </span>
                },
                position: { x: this.props.objProiectInfo[0].screen_x ? this.props.objProiectInfo[0].screen_x : 10, y: this.props.objProiectInfo[0].screen_y ? this.props.objProiectInfo[0].screen_y : screenHeight / 2 }
            }
        )

        for (let i = 0, n = etape.length; i < n; i++) {

            let x = 250 + 10
            let y = 100 + (i * 100)

            let id = etape[i].id

            el.push({
                id: `etapa-${id}`,
                data: {
                    label:
                        <div>
                            <span
                                className='word-ellipsis'
                            >{`${i + 1}. ` + etape[i].denumire} </span>
                            <i

                                onClick={() => { this.insertTask(etape[i], 'down') }}
                                id={`eadd-${id}`}
                                style={{
                                    display: 'none',
                                    position: 'absolute',
                                    bottom: -11,
                                    left: 0,
                                    right: 0,
                                    background: 'green',
                                    width: 'fit-content',
                                    margin: 'auto',
                                    zIndex: 2000,
                                    borderRadius: 20,
                                    color: 'white'
                                }} className='material-icons'>add</i>

                            <i

                                onClick={() => { this.insertTask(etape[i], 'right') }}
                                id={`eaddRight-${id}`}
                                style={{
                                    display: 'none',
                                    position: 'absolute',
                                    bottom: 0,
                                    top: 0,
                                    right: -8,
                                    background: 'green',
                                    width: 'fit-content',
                                    margin: 'auto',
                                    zIndex: 2000,
                                    borderRadius: 20,
                                    color: 'white',
                                    height: 'fit-content'
                                }} className='material-icons'>add</i>
                        </div>

                },
                position: { x: etape[i].screen_x ? etape[i].screen_x : x, y: etape[i].screen_y ? etape[i].screen_y : y }

            })


            el.push({
                id: `p-e${id}`, source: `proiect`, target: `etapa-${id}`
            })

            let taskuriFilter = taskuri.filter(tsk => tsk.id_etapa_proiect === etape[i].id)
            taskuriFilter = taskuriFilter.filter(t => (new Date(this.ut.ParseDataFromSql(t.cand_data)) < new Date(etape[i].durata_pana_la) && new Date(this.ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(etape[i].durata_pana_la)))

            for (let j = 0, m = taskuriFilter.length; j < m; j++) {

             
                let xT = x + 250
                let yT = 100 + (j * 100)
                el.push({
                    id: `taskuri-${taskuriFilter[j].id}`,
                    data: {
                        label:

                            <div>
                                <span
                                    className='word-ellipsis'
                                > {`${i + 1}.${j + 1} ${taskuriFilter[j].titlu}`} </span>
                                <i
                                    onClick={() => { this.insertSubTask(taskuriFilter[j], 'down') }}
                                    id={`tadd-${taskuriFilter[j].id}`}
                                    style={{
                                        display: 'none',
                                        position: 'absolute',
                                        bottom: -11,
                                        left: 0,
                                        right: 0,
                                        background: 'green',
                                        width: 'fit-content',
                                        margin: 'auto',
                                        zIndex: 2000,
                                        borderRadius: 20,
                                        color: 'white'
                                    }} className='material-icons'>add</i>


                                <i

                                    onClick={() => { this.insertSubTask(taskuriFilter[j], 'right') }}
                                    id={`taddRight-${taskuriFilter[j].id}`}
                                    style={{
                                        display: 'none',
                                        position: 'absolute',
                                        bottom: 0,
                                        top: 0,
                                        right: -8,
                                        background: 'green',
                                        width: 'fit-content',
                                        margin: 'auto',
                                        zIndex: 2000,
                                        borderRadius: 20,
                                        color: 'white',
                                        height: 'fit-content'
                                    }} className='material-icons'>add</i>
                            </div>

                    },
                    position: { x: taskuriFilter[j].screen_x ? taskuriFilter[j].screen_x : xT, y: taskuriFilter[j].screen_y ? taskuriFilter[j].screen_y : yT }
                })

                el.push({
                    id: `e-t${taskuriFilter[j].id}`, source: `etapa-${id}`, target: `taskuri-${taskuriFilter[j].id}`
                })


                let subTaskuriFilter = subTaskuri.filter(tsk => tsk.id_task_parent === taskuriFilter[j].id)

                for (let k = 0, l = subTaskuriFilter.length; k < l; k++) {
                    let xST = xT + 250
                    let yST = 100 + (k * 100)

                    el.push({
                        id: `subt-${subTaskuriFilter[k].id}`,
                        data: {
                            label:
                                <div>
                                    <span
                                        className='word-ellipsis'
                                    > {`${i + 1}.${j + 1}.${k + 1} ${subTaskuriFilter[k].titlu}`} </span>
                                    <i
                                        id={`stadd-${subTaskuriFilter[k].id}`}
                                        style={{
                                            display: 'none',
                                            position: 'absolute',
                                            bottom: -11,
                                            left: 0,
                                            right: 0,
                                            background: 'green',
                                            width: 'fit-content',
                                            margin: 'auto',
                                            zIndex: 2000,
                                            borderRadius: 20,
                                            color: 'white'
                                        }} className='material-icons'>add</i>
                                </div>

                        },
                        position: { x: subTaskuriFilter[k].screen_x ? subTaskuriFilter[k].screen_x : xST, y: subTaskuriFilter[k].screen_y ? subTaskuriFilter[k].screen_y : yST }
                    })

                    el.push({
                        id: `t-st${subTaskuriFilter[k].id}`, source: `taskuri-${taskuriFilter[j].id}`, target: `subt-${subTaskuriFilter[k].id}`
                    })
                }
            }
        }

        console.log('el :>> ', el);
        this.setState({
            elements: el,
            showThink: true
        })

        // for(let i = 0 , n = taskuri.length ; i < n ; i++){
        //     el.push({
        //         id:`taskuri-${taskuri[i].id}`,
        //         data:{label:taskuri[i].denumire}
        //     })
        // }
    }


    tableView = () => {

        let etape = [...this.props.listEtape]
        let taskuri = [...this.props.listTaskuri]
        let subTaskuri = [...this.props.listSubTaskuri]

        let container = []

        let etapaRows = []
        for (let i = 0, n = etape.length; i < n; i++) {




            let taskuriFilter = taskuri.filter(tsk => tsk.id_etapa_proiect === etape[i].id)
            taskuriFilter = taskuriFilter.filter(t => (new Date(this.ut.ParseDataFromSql(t.cand_data)) < new Date(etape[i].durata_pana_la) && new Date(this.ut.ParseDataFromSql(t.pana_cand_data)) <= new Date(etape[i].durata_pana_la)))



            etapaRows.push(<Grid key={`etapa${i}`} item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h3 style={{ marginBottom: 20, width: 'fit-content', fontSize: 16 }}>Stadiul {i + 1} - {etape[i].denumire}</h3>
                <TabelTaskIdeea
                    etapa={etape[i]}
                    taskuri={taskuriFilter}
                    changeTask={this.props.changeTask}
                    updateTaskTitle={this.props.updateTaskTitle}
                    dataStartChange={this.props.dataStartChange}
                    dtDataStart={this.props.dtDataStart}
                    dataFinishChange={this.props.dataFinishChange}
                    dtDataFinish={this.props.dtDataFinish}
                    getTaskDates={this.props.getTaskDates}
                    isUtlizatorOpen={this.props.isUtlizatorOpen}
                    closeUtilizator={this.props.closeUtilizator}
                    listUsers={this.props.listUsers}
                    userClick={this.props.userClick}
                    insertTask={this.props.insertTask}
                    editTask={this.props.editTask}
                />

            </Grid>)


        }

        container.push(<Grid key={'etapeContaine'} container>
            {etapaRows}
        </Grid>)


        return container
    }


    dragStart = (ev, n) => {



    }

    insertTask = (e, direction) => {

        console.log('etapa :>> ', e);

        let elements = [...this.state.elements]

        console.log('elements :>> ', elements);


        let idxElm = elements.findIndex(el => el.id === 'e-tnew')


        if (idxElm === -1) {
            let idx = elements.findIndex(elI => elI.id === `etapa-${e.id}`)

            console.log('idx :>> ', idx);

            if (idx !== -1) {
                console.log('elements[idx] :>> ', elements[idx]);

                let newEl = {
                    id: `taskurinew`,
                    style: { width: '200px' },
                    data: {
                        label:

                            <div>
                                <input
                                    style={{ width: '100%' }}
                                    id={`task-title`}
                                    className='inpThink'
                                    placeholder='Introdu numele si apasa Enter'
                                    type='text'
                                    onKeyPress={this.taskInsert}


                                />

                            </div>

                    },
                    position: direction !== 'right' ? { x: elements[idx].position.x, y: elements[idx].position.y + 50 } : { x: elements[idx].position.x + 200, y: elements[idx].position.y }
                }

                elements.push(
                    newEl
                )

                elements.push(
                    {
                        id: `e-tnew`, source: `etapa-${e.id}`, target: `taskurinew`
                    }
                )

                this.setState({
                    elements: elements,
                    elSelectat: newEl,
                    etapaSelectata: e
                })
            }
        }




    }



    insertSubTask = (t, direction) => {
        console.log('task :>> ', t);

        let elements = [...this.state.elements]

        console.log('elements :>> ', elements);


        let idx = elements.findIndex(elI => elI.id === `taskuri-${t.id}`)

        if (idx !== -1) {
            console.log('elements[idx] :>> ', elements[idx]);

            let newEl = {
                id: `subtaskurinew`,
                style: { width: '200px' },
                data: {
                    label:

                        <div>
                            <input
                                style={{ width: '100%' }}
                                id={`subtask-title`}
                                className='inpThink'
                                placeholder='Introdu numele si apasa Enter'
                                type='text'
                                onKeyPress={this.subTaskInsert}


                            />

                        </div>

                },
                position: direction !== 'right' ? { x: elements[idx].position.x, y: elements[idx].position.y + 50 } : { x: elements[idx].position.x + 200, y: elements[idx].position.y }
            }

            elements.push(
                newEl
            )

            elements.push(
                {
                    id: `t-stnew`, source: `taskuri-${t.id}`, target: `subtaskurinew`
                }
            )

            this.setState({
                elements: elements,
                elSelectat: newEl,
                taskSelectat: t
            })
        }
    }


    subTaskInsert = async (e) => {

        if (e.key === 'Enter') {
            let fs = new FromServer();

            let val = document.getElementById('subtask-title').value

            let obj = {
                id_task_parent: this.state.taskSelectat.id,
                cand_data: this.state.taskSelectat.cand_data,
                pana_cand_data: this.state.taskSelectat.cand_data,
                titlu: val,
                id_utilizator_responsabil: this.state.taskSelectat.id_utilizator_responsabil,
                id_proiect: this.state.taskSelectat.id_proiect,
                id_etapa_proiect: this.state.taskSelectat.id_etapa_proiect,
                descriere: '',
                screen_x: this.state.elSelectat.position.x,
                screen_y: this.state.elSelectat.position.y
            }


            console.log('obj :>> ', obj);




            let insertTask = await fs.insertTask(obj)

            if (insertTask.success) {



                // console.log('insertTask :', insertTask);
                obj.id = insertTask.content[0].id
                obj.nume = ''



                await this.props.getData()
                this.elements()
            }
        }


    }


    taskInsert = async (e) => {
        if (e.key === 'Enter') {

            let val = document.getElementById('task-title').value


            console.log('val :>> ', val);
            let fs = new FromServer();

            let ls = new LocalStorage()

            let ws = new Ws();



            // console.log('e :', e);



            let obj = {
                id_utilizator_responsabil: '',
                titlu: val,
                id_proiect: this.props.objProiectInfo[0].id,
                id_etapa_proiect: this.state.etapaSelectata.id,
                color: 'rgb(108, 96, 197)',
                statusul: '',
                descriere: '',
                cand_data: this.state.etapaSelectata.durata_de_la,
                pana_cand_data: this.state.etapaSelectata.durata_de_la,
                screen_x: this.state.elSelectat.position.x,
                screen_y: this.state.elSelectat.position.y

            }


            console.log('obj :>> ', obj);

            console.log('obj :', obj);

            let insertTask = await fs.insertTask(obj)

            if (insertTask.success) {



                // console.log('insertTask :', insertTask);
                obj.id = insertTask.content[0].id
                obj.nume = ''

                await this.props.getData()
                this.elements()


            }
        }
    }


    dragEnd = async (ev, n) => {



        console.log('n :>> ', n);
        // console.log('ev :>> ', ev);

        let id = n.id.split('-')[1]

        console.log('id :>> ', id);

        if (n.id.indexOf('proiect') !== -1) {
            console.log('updateProiect :>> ',);

            console.log('this.props.objProiectInfo[0] :>> ', this.props.objProiectInfo[0]);


            let updateProiect = await this.ws.update('proiecte', { screen_x: n.position.x, screen_y: n.position.y }, { id: this.props.objProiectInfo[0].id })
            console.log('updateProiect :>> ', updateProiect);
        }
        else if (n.id.indexOf('etapa') !== -1) {
            console.log('updateEtapa :>> ');

            console.log('n.position.x :>> ', n.position.x);
            console.log('id :>> ', id);
            console.log('n.position.y :>> ', n.position.y);

            let updateEtapa = await this.ws.update('proiecte_etape', { screen_x: n.position.x, screen_y: n.position.y }, { id: id })

            console.log('updateEtapa :>> ', updateEtapa);

        } else if (n.id.indexOf('taskuri') !== -1) {
            console.log('updateTask :>> ');
            let updateTask = await this.ws.update('taskuri', { screen_x: n.position.x, screen_y: n.position.y }, { id: id })

        } else if (n.id.indexOf('subt') !== -1) {
            console.log('updateSubTask :>> ',);

            let updateSubTask = await this.ws.update('taskuri', { screen_x: n.position.x, screen_y: n.position.y }, { id: id })
        }
    }


    mouseEnter = (ev, n) => {
        console.log('ev :>> ', ev);
        console.log('n :>> ', n);

        console.log('n.label.props.children[1] :>> ', n.data.label.props);

        let id = n.id.split('-')

        if (id[0] === 'etapa') {
            let el = document.getElementById(`eadd-${id[1]}`)
            let elR = document.getElementById(`eaddRight-${id[1]}`)
            el.style.display = 'block'
            elR.style.display = 'block'

        } else if (id[0] === 'taskuri') {

            let el = document.getElementById(`tadd-${id[1]}`)
            let elR = document.getElementById(`taddRight-${id[1]}`)

            if (el) {
                el.style.display = 'block'
                elR.style.display = 'block'
            }

        } else if (id[0] === 'subt') {
            let el = document.getElementById(`stadd-${id[1]}`)

            el.style.display = 'block'
        }



    }

    mouseLeave = (ev, n) => {
        console.log('ev :>> ', ev);
        console.log('n :>> ', n);

        console.log('n.label.props.children[1] :>> ', n.data.label.props);

        let id = n.id.split('-')

        if (id[0] === 'etapa') {
            let el = document.getElementById(`eadd-${id[1]}`)
            let elR = document.getElementById(`eaddRight-${id[1]}`)
            el.style.display = 'none'
            elR.style.display = 'none'

        } else if (id[0] === 'taskuri') {
            let el = document.getElementById(`tadd-${id[1]}`)
            let elR = document.getElementById(`taddRight-${id[1]}`)

            if (el) {
                el.style.display = 'none'
                elR.style.display = 'none'
            }

        } else if (id[0] === 'subt') {
            let el = document.getElementById(`stadd-${id[1]}`)
            el.style.display = 'none'
        }
    }


    hideTableView = () => {

        let table = document.getElementById('tableView')
        let think = document.getElementById('thinkView')


        if (this.state.ascunde) {
            console.log('arata :>> ');
            think.style.height = this.state.thinkViewHeight + 'px'
            table.style.height = this.state.tableViewHeight + 'vh'

            this.setState({ ascunde: false })
        } else {

            console.log('ascunde :>> ');
            think.style.height = 71 + 'vh'
            table.style.height = 0
            this.setState({ ascunde: true })
        }




    }

    onLoad = (reactFlowInstance) => {


        reactFlowInstance.fitView();

    }




    render() {
        return (
            <div style={{ height: '76vh' }}>
                {this.props.listTaskuri.length === 0 && this.state.firstTime &&
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'left', padding: '0 20px' }} >

                        <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(253 189 8)', borderRadius: 30, padding: 10, marginTop: 20 }}>
                            <div>
                                {/* <i style={{ fontSize: 18, verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>error</i> */}
                                <Info style={{ width: 18, height: 18, verticalAlign: '-webkit-baseline-middle', marginRight:10 }}/>
                            </div>
                            <div style={{ padding: '0 10px' }}>
                                <span style={{ fontSize: 14, fontWeight: 400 }}>
                                {this.dictionary.proiecte.welcomeToIdeaView}  <b> {this.dictionary.proiecte.idea} </b> {this.dictionary.proiecte.ideaViewMessage}

                                      </span>
                            </div>
                            <div>
                                <i style={{ fontSize: 18, verticalAlign: '-webkit-baseline-middle', cursor: "pointer" }}
                                    onClick={() => { this.setState({ firstTime: false }) }}
                                    className='material-icons'>clear</i>
                            </div>

                        </div>

                    </Grid>
                }
                <div id="thinkView" style={{
                    height: this.state.thinkViewHeight,
                    transition: 'all .5s linear',
                    position: 'relative'
                }}>

                    {this.state.showThink &&
                        <ReactFlow
                            onLoad={this.onLoad}
                            onNodeDragStop={this.dragEnd}
                            onNodeMouseEnter={this.mouseEnter}
                            onNodeMouseLeave={this.mouseLeave}


                            minZoom={0}
                            defaultZoom={0}
                            elements={this.state.elements} />
                    }


                    <div style={{
                        position: 'absolute',
                        height: 5,
                        bottom: 10,
                        left: 0,
                        right: 0,
                        backgroundColor: 'gray',

                    }}></div>
                    <div
                        onClick={this.hideTableView}
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            margin: 'auto',
                            backgroundColor: 'black',
                            width: 100,
                            color: 'white',
                            borderRadius: 20,
                            zIndex: 1100,
                            cursor: 'pointer'
                        }}>
                        <i className='material-icons'>{this.state.ascunde ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>

                    </div>
                </div>
                <div id="tableView" style={{
                    padding: 20,
                    height: this.state.tableViewHeight + 'vh',
                    transition: 'all .5s linear',
                    overflow: 'scroll',


                }}>


                    {this.tableView()}
                </div>

            </div>

        );
    }
}